<template>
    <ExtendedLayout
        :project="project"
        currentTab="integrations"
    >

        <Panel>

            <form @submit.prevent="submit">

                <ProjectIntegrations v-model="form.integrations" />

                <Button :loading="form.processing" class="mt-6">
                    {{ __('admin::general.update_model', {'model': __('admin::projects.project').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@/Pages/Projects/Edit';
import Panel from "@/Components/Panel";
import Button from "@/Components/Button";
import ProjectIntegrations from "@/Components/ProjectIntegrations";

export default {
    components: {
        ProjectIntegrations,
        Button,
        Panel,
        ExtendedLayout,
    },
    props: {
        errors: Object,
        project: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                integrations: this.project.integrations || [],
            })
        }
    },
    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.$route('admin::projects.integrations.update', { project: this.project.id }));
        }
    },
}
</script>
